import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import { GRU_SAVING_LIST_QUERY, GRU_SAVING_CANCEL_QUERY } from "../Queries";
import useInput from "../../../../Hooks/useInput";
import ListPresenter from "./Presenter/List";
import { toast } from "react-toastify";
import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));
  const page = queryString.page ? queryString.page : 1;
  const gruSavingInfo = queryString.gruSavingInfo
    ? queryString.gruSavingInfo
    : "";
  const commonStatus = queryString.commonStatus ? queryString.commonStatus : "";
  const startDate = queryString.startDate ? queryString.startDate : "";
  const endDate = queryString.endDate ? queryString.endDate : "";
  const keyword = queryString.keyword ? queryString.keyword : "";
  const keywordInput = useInput(keyword);

  const blockSize = 5;
  const first = 15;
  const skip = first * (page - 1);
  const baseUrl =
    "?" +
    (gruSavingInfo ? "gruSavingInfo=" + gruSavingInfo + "&" : "") +
    (commonStatus ? "commonStatus=" + commonStatus + "&" : "") +
    (startDate ? "startDate=" + startDate + "&" : "") +
    (endDate ? "endDate=" + endDate + "&" : "") +
    (keywordInput.value ? "keyword=" + keywordInput.value + "&" : "");

  const { data, loading, error, refetch } = useQuery(GRU_SAVING_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      gruSavingInfo,
      commonStatus,
      keyword,
      startDate,
      endDate,
      skip,
      first,
    },
  });

  const [gruSavingCancelMutation] = useMutation(GRU_SAVING_CANCEL_QUERY);

  const handleSearch = (e) => {
    e.preventDefault();
    history.push(`/gruSavingList${baseUrl}page=1`);
  };

  const handleCancel = async (id) => {
    if (
      !window.confirm(
        "적립을 취소하시겠습니까?\n사용자 잔액에서 적립금액이 차감됩니다."
      )
    ) {
      return;
    }
    try {
      const {
        data: { AdminGruSavingCancel },
      } = await gruSavingCancelMutation({ variables: { id } });
      if (AdminGruSavingCancel) {
        toast.success("취소 처리 되었습니다.");
        refetch();
      }
    } catch (e) {
      console.log(e);
      let errorMessage = "에러가 발생했습니다. 다시 시도해 주세요.";
      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        errorMessage = e.graphQLErrors.map((err) => err.message).join("\n");
      }
      toast.error(errorMessage);
    }
  };

  if (!loading && (error || !data || !data.AdminGruSavingList)) {
    return (
      <div className="alert alert-danger m-t-20">
        적립내역을 불러오지 못했습니다.
        {error && <div className="f-s-12 m-t-5">{error.message}</div>}
      </div>
    );
  }

  return (
    <ListPresenter
      history={history}
      match={match}
      location={location}
      page={page}
      gruSavingInfo={gruSavingInfo}
      commonStatus={commonStatus}
      keyword={keyword}
      keywordInput={keywordInput}
      blockSize={blockSize}
      first={first}
      data={data}
      loading={loading}
      baseUrl={baseUrl}
      handleSearch={handleSearch}
      handleCancel={handleCancel}
    />
  );
});
